'use client';

import { createContext, type ReactNode, useContext, useState } from 'react';
import type { IBreadcrumbItem } from '../_breadcrumb/types';

interface IBreadcrumbOverride {
  label: string;
  parentItems?: IBreadcrumbItem[];
  append?: boolean;
}

interface IHeaderActionsContextValue {
  actions: ReactNode;
  setActions: (actions: ReactNode) => void;
  breadcrumbOverride: IBreadcrumbOverride | null;
  setBreadcrumbOverride: (override: IBreadcrumbOverride | null) => void;
}

const HeaderActionsContext = createContext<IHeaderActionsContextValue>({
  actions: null,
  setActions: () => {},
  breadcrumbOverride: null,
  setBreadcrumbOverride: () => {},
});

export function HeaderActionsProvider({ children }: { children: ReactNode }): ReactNode {
  const [actions, setActions] = useState<ReactNode>(null);
  const [breadcrumbOverride, setBreadcrumbOverride] = useState<IBreadcrumbOverride | null>(null);
  return (
    <HeaderActionsContext.Provider
      value={{ actions, setActions, breadcrumbOverride, setBreadcrumbOverride }}
    >
      {children}
    </HeaderActionsContext.Provider>
  );
}

export function useHeaderActions(): IHeaderActionsContextValue {
  return useContext(HeaderActionsContext);
}
